import { ContainerModule } from "inversify";

import { HttpClient } from "../lib/http-client";
import { HttpClientInterface, Http_Client_DIID } from "./http-client.interface";

export const HttpClientModule = new ContainerModule((bind) => {
    bind<HttpClientInterface>(Http_Client_DIID.symbol).to(HttpClient);
});
